import React from "react";

const Bar = ({ animationDuration, progress }) => {
  return (
    <div className="bar-outer">
      <div className="bar-inner" />
    </div>
  );
};

export default Bar;
